export default "__VITE_ASSET__D_rwA1d3__"